export default "__VITE_ASSET__B0C84QjX__"